import { isNullOrUndefined, isValidDate } from '@/utils/TypeGuards'
import { format } from 'date-fns'

/** anythingToDate() accepts
 * - ISO-Date
 * - epoch as String
 * - epoch as Integer
 * - strings like YYYY-MM-DD 00:00:00.123
 * - null
 * - undefined
 *
 *  and returns a js date object or undefined
 *
 *  this is used to convert ugly dates e.g. label informations nested in a json from a foreign system
 * */
type AnythingToDate = string | number | Date | undefined | null

export function anythingToDate(dateTime: AnythingToDate): Date | undefined {
  if (isNullOrUndefined(dateTime)) {
    return undefined
  }
  try {
    if (typeof dateTime === 'number' || (typeof dateTime === 'string' && /^\d+$/.test(dateTime))) {
      // Handle epoch timestamps
      const timestamp = Number(dateTime)
      const date = new Date(timestamp)
      return isValidDate(date) ? date : undefined
    }
    if (typeof dateTime === 'string') {
      // Handle ISO dates and other string formats
      const date = new Date(dateTime)
      return isValidDate(date) ? date : undefined
    }
    if (dateTime instanceof Date) {
      return isValidDate(dateTime) ? dateTime : undefined
    }
    return undefined
  } catch (error) {
    console.error('Error converting to date:', error, { dateTime })
    return undefined
  }
}

function formatOrNull(anything: AnythingToDate, formatStr: string): string | null {
  const test = anythingToDate(anything)
  if (!test) {
    return null
  } else {
    return format(test, formatStr)
  }
}

// Takes various dates (ISO-Date, epoch, YYYY-MM-DD 00:00:00.123) and converts to chDateTimeFormat
export function formatChDateTime(anything: AnythingToDate): string | null {
  return formatOrNull(anything, 'dd.MM.yyyy HH:mm')
}

// Takes various dates (ISO-Date, epoch, YYYY-MM-DD 00:00:00.123) and converts to chDateFormat
export function formatChDate(anything: AnythingToDate): string | null {
  return formatOrNull(anything, 'dd.MM.yyyy')
}

/** it takes any string and tries to format into a zone iso date string */
export function formatDateTime(anything: AnythingToDate): string | null {
  return formatOrNull(anything, "yyyy-MM-dd'T'00:00:00")
}
